<template>
	<div>
		<transition name="fade">
		<div v-if="loading" class="loading">
			<div v-if="!timedOut">
				<LoaderSVG />
			</div>
			<div v-else class="loading__timeout">
				<p class="loading__timeout-message">This is taking longer than expected.</p>
				<button type="button" class="btn btn--color-dark" @click="reload">Reload Page</button>
			</div>
		</div>
		</transition>
	</div>
</template>

<script>

import LoaderSVG from '@/assets/svg/data-loader.svg'

// Safety-net: if a loading state is somehow never cleared (e.g. a request
// that hangs/never settles), stop showing an endless spinner and give the
// user a way out instead of leaving them stuck forever.
const WATCHDOG_TIMEOUT_MS = 35000

export default {
	name: "Loader",
	components: {
		LoaderSVG,
	},
	data() {
		return {
			loading: false,
			timedOut: false,
			watchdogTimer: null,
		}
	},
	watch: {
		loading(val) {
			this.clearWatchdog()
			this.timedOut = false

			if (val) {
				this.watchdogTimer = setTimeout(() => {
					this.timedOut = true
				}, WATCHDOG_TIMEOUT_MS)
			}
		},
	},
	beforeDestroy() {
		this.clearWatchdog()
	},
	methods: {
		clearWatchdog() {
			if (this.watchdogTimer) {
				clearTimeout(this.watchdogTimer)
				this.watchdogTimer = null
			}
		},
		reload() {
			window.location.reload()
		},
	},
}
</script>
<style lang="scss">
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to  {
  opacity: 0;
}
.loading{
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffffc2;
  z-index: 10000;

  &__timeout {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 20px;

    &-message {
      margin-bottom: 15px;
      font-weight: 600;
    }
  }
}
</style>